import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  AdminApiPaths,
  TApiResponse,
  APIDataProvider,
  TApiPaginationResponse,
} from '../../../api';
import {
  ICoursePermissionTemplate,
  ICoursePermissionTemplateDeleteVerificationData,
} from '.';

export type TAdminCreateCoursePermissionTemplate = {
  name: ICoursePermissionTemplate['name'];
  group: ICoursePermissionTemplate['group'];
  role: ICoursePermissionTemplate['role'];
  user: ICoursePermissionTemplate['user'];
  groupCriteria?: ICoursePermissionTemplate['groupCriteria'];
  groups?: string[];
  roleCriteria?: ICoursePermissionTemplate['roleCriteria'];
  roles?: string[];
  userCriteria?: ICoursePermissionTemplate['userCriteria'];
  users?: string[];
};

export type TAdminGetCoursePermissionTemplates = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
};

export type TAdminUpdateCoursePermissionTemplate = {
  id: string;
  name: ICoursePermissionTemplate['name'];
  group: ICoursePermissionTemplate['group'];
  role: ICoursePermissionTemplate['role'];
  user: ICoursePermissionTemplate['user'];
  groupCriteria?: ICoursePermissionTemplate['groupCriteria'];
  groups?: string[];
  roleCriteria?: ICoursePermissionTemplate['roleCriteria'];
  roles?: string[];
  userCriteria?: ICoursePermissionTemplate['userCriteria'];
  users?: string[];
};

const apiDataProvider = new APIDataProvider();

const adminGetCoursePermissionTemplatesModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
}: TAdminGetCoursePermissionTemplates) => {
  let path = `${AdminApiPaths.adminCoursePermissionTemplates}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${searchText}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<ICoursePermissionTemplate>>
  >(path);

  return response.data;
};

export const adminCreateCoursePermissionTemplate = createAsyncThunk(
  '/admin/course-permission-template/create',
  async (data: TAdminCreateCoursePermissionTemplate) => {
    const path = `${AdminApiPaths.adminCoursePermissionTemplates}`;

    const response = await apiDataProvider.post<
      TApiResponse<ICoursePermissionTemplate>
    >(path, data);

    return response.data;
  }
);

export const adminUpdateCoursePermissionTemplate = createAsyncThunk(
  '/admin/course-permission-template/update',
  async (data: TAdminUpdateCoursePermissionTemplate) => {
    const path = `${AdminApiPaths.adminCoursePermissionTemplates}/${data.id}`;

    const response = await apiDataProvider.put<
      TApiResponse<ICoursePermissionTemplate>
    >(path, data);

    return response.data;
  }
);

export const adminDeleteCoursePermissionTemplate = createAsyncThunk(
  '/admin/course-permission-template/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.adminCoursePermissionTemplates}/${id}`;

    const response = await apiDataProvider.delete<
      TApiResponse<ICoursePermissionTemplate>
    >(path);

    return response.data;
  }
);

export const adminVerifyCoursePermissionTemplateDelete = createAsyncThunk(
  '/admin/course-permission-template/verify-delete',
  async (id: string) => {
    const path = `${AdminApiPaths.adminCoursePermissionTemplates}/verify-delete/${id}`;

    const response = await apiDataProvider.get<
      TApiResponse<ICoursePermissionTemplateDeleteVerificationData>
    >(path);

    return response.data;
  }
);

export const adminGetCoursePermissionTemplates = createAsyncThunk(
  '/admin/settings/course-permission-template/list',
  adminGetCoursePermissionTemplatesModule
);

export const adminGetCoursePermissionTemplatesForDropDown = createAsyncThunk(
  '/admin/settings/course-permission-template/dropdown-list',
  adminGetCoursePermissionTemplatesModule
);
